
import {Component} from 'vue-property-decorator';
import {SET_DESEASE, SET_LOCATIONS} from '@/store/mutationTypes';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import DebounceMixin from '@/mixins/DebounceMixin';
import {Biodata, biodataModule} from '@/store/modules/biodata';
import {swalSuccess, swalError} from '@/plugins/swal';

@Component
export default class FormBiodata extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  @biodataModule.State('locations') locations!: Biodata[];
  @biodataModule.Mutation(SET_LOCATIONS) setLocation!: Function;
  @biodataModule.Action('getLocation') getLocation!: Function;
  @biodataModule.State('desease') desease!: Biodata[];
  @biodataModule.Mutation(SET_DESEASE) setDesease!: Function;
  @biodataModule.Action('getDesease') getDesease!: Function;
  radioGroup = false;
  disableButton = false;
  menu = false;
  listpenyakit = [];
  deseaseForm: any = null;
  form = {
    eye_left: '',
    eye_right: '',
    cylindrical_left: '',
    cylindrical_right: '',
    allergies: '',
    disease: [],
    disability: '',
    disease_status: false,
  };
  get rules() {
    return {
      eye_left: '',
      eye_right: '',
      cylindrical_left: '',
      cylindrical_right: '',
      allergies: '',
      disease: '',
      disability: 'required',
    };
  }
  async mounted() {
    this.fecthDeseaseList();
    await this.fetchDetail();
  }
  destroyed() {
    this.setLocation([]);
  }
  async fecthDeseaseList() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('biodata/getDesease');
      this.finishLoading('detail');
      this.listpenyakit = data;
    } catch (e) {
      this.catchError(e);
    }
  }
  async fetchDetail() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('biodata/getHealth');
      this.finishLoading('detail');
      if (data !== null) {
        this.form = data;
        this.radioGroup = data.disease_status || false;
        this.deseaseForm = data.disease?.split(',') || null;
      }
    } catch (e) {
      this.catchError(e);
    }
  }

  async getFormData() {
    this.form.disease = this.deseaseForm?.join() || null;
    this.form.disease_status = this.radioGroup;

    return this.form;
  }

  async onSubmit() {
    try {
      this.startLoading('saving');
      const formData = await this.getFormData();

      const res = await this.$store.dispatch('biodata/updateHealth', formData);

      if (res.status === 200) {
        swalSuccess.fire({
          title: 'Success!',
          text: res.data.message,
        });
        this.finishLoading('saving');
      }
      this.disableButton = false;
      this.fetchDetail();
      this.$router.push('/education');
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
}
